import React from 'react';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';

const shippingAddress = ({ cart }) => {
  const deliveryAddress = _get(cart, 'deliveryInfo.deliveryAddress');
  const addressName = `${deliveryAddress?.firstName} ${deliveryAddress?.lastName}`;
  const {
    line1 = '',
    line2 = '',
    line3 = '',
    landmark = '',
    town = '',
    district = '',
    state = '',
    postalCode = '',
    phone = '',
    country = '',
    codEligible = false
  } = deliveryAddress || {};
  return (
    <div className="address-container">
      <div className="address-summary">
        <h3 className="card-header">Shipping Address</h3>
        {!_isEmpty(deliveryAddress) && (
          <div>
            <section className="address-detail addressName">
              <span>{addressName}</span>
            </section>
            <section className="address-detail address">
              <span>{line1 ? `${line1}, ` : ''}</span>
              <span>{line2 ? `${line2}, ` : ''}</span>
              <span>
                {landmark ? `${landmark}, ` : ''}
                {line3 ? `${line3}, ` : ''}
                {town ? `${town}, ` : ''}
              </span>
              <span>
                {district && state
                  ? `${district}, ${state}`
                  : district
                  ? `${district}`
                  : state
                  ? `${state}, `
                  : ''}
              </span>
              <span>
                {`, ${country.name}`}
                {postalCode ? `- ${postalCode}` : ''}
              </span>
            </section>
            <section className="address-detail phone">
              <span className="label">Mobile: </span>
              <span className="value">{phone}</span>
            </section>
          </div>
        )}
      </div>
      <div className="cod-detail">{codEligible && <span>Cash on delivery available.</span>}</div>
    </div>
  );
};

export default shippingAddress;
